/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
import analyticsCrossProductInteractionClient, {
	type InteractionSessionTrackingOptions,
} from './analyticsCrossProductInteractionClient';
import { validProducts } from './config/productList';
import { URL_QUERY_PARAM_INTERACTION_SESSION } from './generateUrlWithParams';
import useCrossProductUrlWrapper, {
	type CrossProductUrlOptions,
} from './useCrossProductUrlWrapper';

/**
 * @deprecated Use `import AnalyticsCrossProductInteractionClient, { CrossProductUrlOptions, InteractionSessionTrackingOptions, URL_QUERY_PARAM_INTERACTION_SESSION, validProducts } from '@atlassiansox/analytics-cross-product-interaction-client'` instead.
 */
export {
	analyticsCrossProductInteractionClient as default,
	type CrossProductUrlOptions,
	type InteractionSessionTrackingOptions,
	useCrossProductUrlWrapper,
	URL_QUERY_PARAM_INTERACTION_SESSION,
	validProducts,
};
